module.exports = __webpack_public_path__ + "img/nature10.6b9d91ba.jpg";